import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _40302ad8 = () => interopDefault(import('../pages/countries.vue' /* webpackChunkName: "pages/countries" */))
const _76867511 = () => interopDefault(import('../pages/help.vue' /* webpackChunkName: "pages/help" */))
const _d0846dee = () => interopDefault(import('../pages/no-subscription.vue' /* webpackChunkName: "pages/no-subscription" */))
const _6e9b87a8 = () => interopDefault(import('../pages/redirect.vue' /* webpackChunkName: "pages/redirect" */))
const _ed204832 = () => interopDefault(import('../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _411bc49c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _b171fd98 = () => interopDefault(import('../pages/_countryCode.vue' /* webpackChunkName: "pages/_countryCode" */))
const _e25a5e92 = () => interopDefault(import('../pages/_countryCode/index.vue' /* webpackChunkName: "pages/_countryCode/index" */))
const _de132b7e = () => interopDefault(import('../pages/_countryCode/_disciplineCode.vue' /* webpackChunkName: "pages/_countryCode/_disciplineCode" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'hash',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/countries",
    component: _40302ad8,
    name: "countries"
  }, {
    path: "/help",
    component: _76867511,
    name: "help"
  }, {
    path: "/no-subscription",
    component: _d0846dee,
    name: "no-subscription"
  }, {
    path: "/redirect",
    component: _6e9b87a8,
    name: "redirect"
  }, {
    path: "/terms",
    component: _ed204832,
    name: "terms"
  }, {
    path: "/",
    component: _411bc49c,
    name: "index"
  }, {
    path: "/:countryCode",
    component: _b171fd98,
    children: [{
      path: "",
      component: _e25a5e92,
      name: "countryCode"
    }, {
      path: ":disciplineCode",
      component: _de132b7e,
      name: "countryCode-disciplineCode"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
